export type CompositionCheckStatus = 'complete' | 'partial' | 'not-comparable';

export type CompositionWarning = {
    rule: string;
    parent: string;
    sumGPer100g: number;
    parentGPer100g: number;
    toleranceGPer100g: number;
    referenceBookId?: string;
    referenceBookCode?: string;
};

export type CompositionBranch = {
    code: string;
    status: CompositionCheckStatus;
    hasRoot: boolean;
    hasParts: boolean;
    comparable: boolean;
};

export type CompositionCheck = {
    status: CompositionCheckStatus;
    warnings: CompositionWarning[];
    branches: CompositionBranch[];
    referenceBookId?: string;
    referenceBookCode?: string;
};

export const compositionStatusBadgeClass = (status?: string): string => {
    switch (status) {
        case 'complete':
            return 'badge badge_success';
        case 'not-comparable':
            return 'badge';
        default:
            return 'badge badge_warning';
    }
};

export const isCompositionCheck = (value: unknown): value is CompositionCheck => {
    if (!value || typeof value !== 'object') {
        return false;
    }
    const record = value as { status?: unknown; warnings?: unknown; branches?: unknown };
    return typeof record.status === 'string' && Array.isArray(record.warnings) && Array.isArray(record.branches);
};
